export const sitecoreRouteNames = {
  home: 'home',
  redirect: 'redirect',
  errors: {
    server: '500',
    pageNotFound: '400',
    application: 'application-error'
  }
};
